import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext<ThemeContext | null>(null);

type ThemeTypes = "dark" | "light";

interface ThemeContext {
  theme: ThemeTypes;
  changeTheme: (theme: ThemeTypes) => void;
}

// Provider
export const ThemeProvider = ({ children }: { children: any }) => {
  const [theme, setIsDark] = useState<ThemeTypes>("light");

  useEffect(() => {
    const rootElement = document?.getElementById("root");

    if (rootElement) {
      rootElement.removeAttribute("data-theme");

      if (theme === "dark") {
        rootElement.setAttribute("data-theme", "dark");
      } else {
        rootElement.setAttribute("data-theme", "light");
      }
    }
  }, [theme]);

  const changeTheme = (data: ThemeTypes) => {
    if (theme === data) {
      setIsDark("dark");
    } else {
      setIsDark("light");
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Listener
export const useThemeListener = () => {
  return useContext(ThemeContext) as ThemeContext;
};
